// The ONE code admission rule, mirrored from the waitlist-svc domain
// (degencoinflip-svc domains/campaigns/waitlist/src/codes.ts). The server is
// the authority; this copy exists so the console can answer per line BEFORE
// a submit and label the server's rejections in the same words.
//
// In words: uppercase letters and digits in segments of 2-32, joined by
// single dashes. No leading/trailing dash, no dots/underscores/spaces/
// unicode, max 64 total. Lowercase input is normalized up first.
// Design: Vault wiki/waitlist-operator-design.md section 1.
export const CODE_SHAPE = /^[A-Z0-9]{2,32}(?:-[A-Z0-9]{2,32})*$/;
export const CODE_MAX_LENGTH = 64;

export const SHAPE_HINT = 'A–Z, 0–9, dashes · 2–64 chars';

export function normalizeCode(input) {
  return String(input ?? '')
    .trim()
    .toUpperCase();
}

export function isValidCode(input) {
  const code = normalizeCode(input);
  return code.length > 0 && code.length <= CODE_MAX_LENGTH && CODE_SHAPE.test(code);
}

/** Why a string fails, in the words the operator sees. */
export function shapeProblem(input) {
  const code = normalizeCode(input);
  if (code.length === 0) return 'empty';
  if (code.length > CODE_MAX_LENGTH) return `longer than ${CODE_MAX_LENGTH} characters`;
  if (!CODE_SHAPE.test(code)) return 'codes are A–Z, 0–9 and dashes only';
  return null;
}
